<div class="menu">
  <div class="menu-header">
    <div class="menu-header-inner" data-testid="menu-container">
      <a class="menu-logo" data-testid="header-logo" [routerLink]="['/']" aria-label="Instaclause">
        <ui-inline-svg class="menu-logo-icon" name="instaclause-horizontal-logo"></ui-inline-svg>
      </a>

      @if (user) {
        <div class="menu-actions">
          <span class="menu-greeting">{{ 'MENU.GREETING' | transloco: { name: user.displayName || '' } }}</span>

          <a
            class="menu-icon-btn"
            [routerLink]="['contracts']"
            routerLinkActive="is-active"
            uiTooltip
            [tooltipText]="'MENU.DOCUMENTS' | transloco"
            [tooltipPosition]="'bottom'">
            <ui-inline-svg class="icon-file-text" name="file-text"></ui-inline-svg>
          </a>

          @if (hasOffice) {
            <a
              class="menu-icon-btn"
              [routerLink]="['customers']"
              routerLinkActive="is-active"
              uiTooltip
              [tooltipText]="'MENU.CUSTOMERS' | transloco"
              [tooltipPosition]="'bottom'">
              <ui-inline-svg name="users"></ui-inline-svg>
            </a>
          }

          <ui-help-hub></ui-help-hub>

          @if (isAdmin) {
            <a
              class="menu-icon-btn"
              [routerLink]="['settings']"
              routerLinkActive="is-active"
              uiTooltip
              [tooltipText]="'MENU.SETTINGS' | transloco"
              [tooltipPosition]="'bottom'">
              <ui-inline-svg class="icon-settings" name="settings"></ui-inline-svg>
            </a>
          }

          <button
            type="button"
            class="menu-icon-btn"
            disabled
            uiTooltip
            [tooltipText]="'MENU.NOTIFICATIONS' | transloco"
            [tooltipPosition]="'bottom'">
            <ui-inline-svg name="bell"></ui-inline-svg>
          </button>

          <!-- rel="opener" is deliberate: a session-only login (Remember me off) lives in
               sessionStorage, which a new tab only inherits from its opener. With noopener the
               Composer tab opens logged out. The target is our own app, so it is safe. -->
          <a
            class="menu-accountant"
            data-testid="header-accountant"
            [attr.href]="canAccessComposer ? composerUrl : null"
            target="_blank"
            rel="opener"
            [attr.aria-disabled]="!canAccessComposer"
            uiTooltip
            [tooltipText]="'MENU.APP_NAME' | transloco"
            [tooltipPosition]="'bottom'">
            <ui-inline-svg class="menu-accountant-icon" name="edit"></ui-inline-svg>
            <span>{{ 'MENU.APP_NAME' | transloco }}</span>
          </a>

          <app-ui-language [pagePosition]="'top'"></app-ui-language>

          <button
            type="button"
            class="menu-icon-btn"
            (click)="logout()"
            uiTooltip
            [tooltipText]="'MENU.LOGOUT' | transloco"
            [tooltipPosition]="'bottom'">
            <ui-inline-svg name="log-out"></ui-inline-svg>
          </button>
        </div>
      } @else {
        <span class="menu-greeting">{{ 'MENU.LOGIN' | transloco }}</span>
        <app-ui-language [pagePosition]="'top'"></app-ui-language>
      }
    </div>
  </div>

  @if (user) {
    <nav class="menu-breadcrumb-bar">
      <ul class="menu-breadcrumb">
        <li class="menu-breadcrumb-item">
          <a
            class="menu-breadcrumb-link menu-breadcrumb-home"
            data-testid="header-home"
            [routerLink]="['/contracts']"
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="{ exact: true }"
            ariaCurrentWhenActive="page"
            [attr.aria-label]="'MENU.HOME' | transloco"
            uiTooltip
            [tooltipText]="'MENU.HOME' | transloco"
            [tooltipPosition]="'bottom'">
            <ui-inline-svg name="home"></ui-inline-svg>
          </a>
        </li>
        @for (item of breadcrumb(); track $index) {
          <ui-inline-svg class="menu-breadcrumb-separator" name="chevron-right"></ui-inline-svg>
          <li class="menu-breadcrumb-item">
            <a
              [routerLink]="item.path"
              class="menu-breadcrumb-link"
              [class.is-active]="$index === breadcrumb().length - 1">
              {{ item.titleKey ? (item.titleKey | transloco) : item.title }}
            </a>
          </li>
        }
      </ul>

      <span class="menu-version-badge" data-testid="header-version">{{ appVersion }}</span>
    </nav>
  }
</div>
